<div class="ui stackable inverted blue borderless menu"
	style="border-radius: 0;"
	[style.margin-bottom]="isMobile ? '0' : '35px'">
	<div class="ui fluid container"
		[style.padding-left]="!isLargeMonitor ? (isRegularMonitor ? '100px' : '20px') : '200px'"
		[style.padding-right]="!isLargeMonitor ? (isRegularMonitor ? '100px' : '20px') : '200px'">
		<div class="item">
			NATO System for Tracking Entitlements & Privileges

			<ng-content select="[title]"></ng-content>
		</div>

		<div class="ui simple dropdown right floated item">
			<ng-container *ngIf="!isImpersonated">
				<i class="user outline icon"></i>
				{{currentUser}}
			</ng-container>

			<div class="ui large red label"
				style="margin: 0"
				*ngIf="isImpersonated">
				<i class="eye outline icon"></i>
				{{currentUser}}
			</div>

			<i class="dropdown icon"></i>

			<div class="menu">
				<button class="item"
					*ngIf="isAdministrator && !isImpersonated"
					style="width: 100%;"
					(click)="impersonateModal.toggle()">
					<i class="key icon"></i>Impersonate&nbsp;
				</button>

				<button class="item"
					style="width: 100%;"
					*ngIf="!isImpersonated"
					(click)="twoFactorModal.toggle()">
					<i class="shield alternate icon"></i>Two-factor Auth &nbsp;
				</button>

				<button class="item"
					style="width: 100%;"
					(click)="logout()">
					<i class="door open icon"></i>Log Out
				</button>
			</div>
		</div>
	</div>
</div>

<div class="ui fluid container"
	[style.padding-left]="!isLargeMonitor ? (isRegularMonitor ? '100px' : (isMobile ? '0' : '20px')) : '200px'"
	[style.padding-right]="!isLargeMonitor ? (isRegularMonitor ? '100px' : (isMobile ? '0' : '20px')) : '200px'"
	[style.padding-bottom]="isMobile ? '0' : '50px'">

	<div class="ui two column stackable padded grid"
		[class.container-shadow]="!isMobile">
		<div class="left attached stretched column"
			style="width: 250px; padding: 0">
			<div class="ui left attached horizontally fitted segment">
				<a [attr.data-tooltip]="appVersion"
					data-variation="small blue"
					style="display: table; margin: 10px auto 0"
					href="">
					<img class="ui small image"
						src="assets/images/logo.png"
						style="width: 150px;">
				</a>

				<ng-content select="[menu]"></ng-content>

				<br />
			</div>
		</div>

		<div class="right attached stretched column"
			style="width: calc(100% - 250px); padding: 0">
			<div class="ui right attached padded segment">
				<ng-content select="[content]"></ng-content>
			</div>
		</div>
	</div>
</div>

<sm-modal #impersonateModal
	[isTiny]="true"
	[isLoading]="isImpersonating"
	(closeEvent)="searchUserResult = null">
	<ng-container header>
		<i class="key icon"></i>
		Impersonate User
	</ng-container>

	<ng-container content>
		<div class="ui form">
			<div class="field">
				<label>User Name:</label>
				<app-lookup [onSearch]="searchUser" [(result)]="searchUserResult" />
			</div>

			<strong>Note</strong>: The session for the impersonated user is intentionally short (5m), after which the impersonating user is automatically restored.
		</div>

		<app-error-message [errors]="impersonateErrors"></app-error-message>
	</ng-container>

	<ng-container actions>
		<button class="ui basic right labeled icon button"
			(click)="searchUserResult = null; impersonateModal.toggle()">
			Cancel
			<i class="cancel icon"></i>
		</button>
		<button class="ui primary right labeled icon button"
			[disabled]="!searchUserResult"
			(click)="impersonateUser()">
			Impersonate
			<i class="check icon"></i>
		</button>
	</ng-container>
</sm-modal>

<sm-modal #twoFactorModal
	[isTiny]="askForCode"
	[isLoading]="isTwoFactorLoading"
	(closeEvent)="cancel2F()">
	<ng-container header>
		<i class="shield alternate icon"></i>
		Two-factor Authentication (2FA)
	</ng-container>

	<ng-container content>
		@if (!askForCode) {
		<div class="ui secondary menu">
			<a class="item"
				[class.active]="showMobileAuth"
				(click)="showMobileAuth = true"
				style="cursor: pointer">
				<i class="alternate big mobile icon"></i>
				Mobile Authenticator
			</a>
			<a class="item"
				[class.active]="!showMobileAuth"
				(click)="showMobileAuth = false"
				style="cursor: pointer">
				<i class="big envelope outline icon"></i>
				Email Authenticator
			</a>
		</div>

		@if (authenticator) {

		@if (showMobileAuth) {
		<div class="ui bottom active attached tab">

			@if (authenticator.mobileEnabled && authenticator.mobile == null) {
			<div class="ui attached segment">
				<p>
					There is an authenticator registered for your NSTEP account.<br />
					<button class="ui primary tertiary button"
						style="padding: 0 !important;"
						(click)="resetAuthenticator()">Click here</button> if you want to reset it.
				</p>
			</div>
			}
			@else if (authenticator.mobile != null) {
			<div class="ui attached segment">
				<p>We recommend installing "Google Authenticator" app and following these steps:</p>
			</div>

			<div class="ui attached segment">
				<div class="ui two column stackable grid">
					<div class="row">
						<div class="ui vertical divider">Or</div>

						<div class="column">
							<ol>
								<li>Open "Google Authenticator" app.</li>
								<li>Authenticate in the app if desired or necessary.</li>
								<li>Click the "+" button in the right corner.</li>
								<li>Select "Scan a QR code".</li>
								<li>Point the camera at the QR image below.</li>
							</ol>

							<div style="text-align: center;">
								<qr-code [value]="authenticator.mobile.authenticatorUri"
									size="300"
									errorCorrectionLevel="M" />
							</div>
						</div>

						<div class="column">
							<ol>
								<li>Open "Google Authenticator" app.</li>
								<li>Authenticate in the app if desired or necessary.</li>
								<li>Click the "+" button in the right corner.</li>
								<li>Select "Enter a setup key".</li>
								<li>Enter "Account name", e.g. "NSTEP".</li>
								<li>Select the field "Key" and input the values below.</li>
								<li>Finish by pressing "Add".</li>
							</ol>

							<br />

							<div style="text-align: center;">
								<div class="ui big labels">
									@for (part of authenticator.mobile.sharedKey; track $index) {
									<div class="ui label">
										<strong>{{part}}</strong>
									</div>
									}
								</div>
							</div>
						</div>

					</div>
				</div>
			</div>

			<div class="ui attached segment">
				After you click the button below, we will request a code to confirm the authenticator.
			</div>
			}
		</div>
		}
		@else {
		<div class="ui bottom active attached tab">
			@if (authenticator.emails.length) {
			<div class="ui attached segment">
				<div class="ui list"
					style="max-height: 410px; overflow-y: auto;">
					@for (email of authenticator.emails; track $index) {
					<div class="item">
						<br />

						<label>
							<i class="large envelope outline icon"></i>&nbsp;{{email}}&nbsp;
						</label>

						<button class="ui tiny red basic button"
							(click)="removeEmail(email)"
							*ngIf="authenticator.emails.length > 1">
							Remove
						</button>

						<br />
					</div>
					<br />
					}


				</div>
			</div>
			}

			<div class="ui attached segment">
				<div class="ui form">
					<div class="inline field" app-field [errors]="errors">
						<div class="ui input">
							<input type="text"
								placeholder="New Email"
								[(ngModel)]="newEmail" style="min-width: 300px;">
						</div>
					</div>
				</div>
			</div>

			<div class="ui attached segment">
				After you click the button below, we will send an email with the code and request it to confirm the authenticator.
			</div>
		</div>
		}
		}
		}
		@else {
		<div class="ui attached segment">
			<div class="ui form"
				style="max-width: 350px; margin: 0 auto">
				<div class="field" app-field [errors]="errors">
					<label style="margin-bottom: 15px;">
						<i class="shield alternate icon"></i>
						Please enter code from authenticator:<br />
					</label>

					<div class="ui six wide fields"
						style="margin-bottom: 15px;">
						<div class="field" *ngFor="let num of [].constructor(6); let i = index">
							<input id="digit-{{i}}"
								type="text"
								maxlength="1"
								pattern="[0-9]"
								inputmode="numeric"
								style="font-weight: bold; text-align: center; font-size: larger; padding-left: 0; padding-right: 0;"
								(input)="handleInput($event, i)"
								(keydown)="handleKeyDown($event, i)"
								(paste)="handlePaste($event)"
								[(ngModel)]="code[i]" />
						</div>
					</div>
				</div>
			</div>
		</div>
		}
	</ng-container>

	<ng-container actions>
		<button class="ui basic right labeled icon button"
			(click)="cancel2F()">
			Cancel
			<i class="cancel icon"></i>
		</button>
		<button class="ui primary right labeled icon button"
			(click)="save2F()"
			[disabled]="!this.showMobileAuth && !this.askForCode && !newEmail">
			Save
			<i class="save icon"></i>
		</button>
	</ng-container>
</sm-modal>